import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import storage from '../../storage'
import StationMenuItem from './StationMenuItem'
import { fetchServiceStations } from '../../actions/remote_api'
import { switchStation } from '../../actions/station'
import AppBar from '../../components/AppBar'

class StationScene extends React.Component {
  componentDidMount() {
    const { serviceStations, fetchServiceStations } = this.props
    if (!serviceStations) fetchServiceStations()
  }

  handleStationClick = (station) => {
    const info = storage.info()
    storage.saveInfo({
      ...info,
      serviceId: station.serviceId,
      serviceClass: station.serviceClass,
      serviceDisplayName: station.serviceDisplayName,
      stationId: station.id,
      stationName: station.name,
    })
    this.props.switchStation({
      serviceId: station.serviceId,
      stationId: station.id,
    })
    this.props.history.push('/checkin')
  }

  render() {
    const { serviceStations } = this.props
    const info = storage.info()
    const serviceByStation = (serviceStations || []).find(
      (s) => s.name === info.serviceName,
    )
    const stations = serviceByStation ? serviceByStation.stations : []

    if (stations.length < 1) {
      return (
        <div className="min-h-screen bg-gray-50">
          <AppBar header={info.serviceName} subHeader="Stations" />
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-12">
            <div className="bg-white rounded-lg shadow-sm p-12 text-center">
              <svg
                className="mx-auto h-12 w-12 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
              <h3 className="mt-4 text-lg font-medium text-gray-900">
                No stations found
              </h3>
              <p className="mt-2 text-sm text-gray-500">
                There are no stations available for this service.
              </p>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className="min-h-screen bg-gray-50">
        <AppBar header={info.serviceName} subHeader="Stations" />
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-12">
          <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {stations.map((station) => (
              <StationMenuItem
                key={station.id}
                station={station}
                onStationClick={this.handleStationClick}
              />
            ))}
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(
  connect(
    ({ fetch }) => ({
      serviceStations: fetch.serviceStation
        ? fetch.serviceStation.list
        : undefined,
    }),
    { fetchServiceStations, switchStation },
  )(StationScene),
)
